
export function useSlideTitle() {
  const title = `Historical Commodity Price Development – Summary (all commodities)`;
  return title;
}